export default __webpack_public_path__ + "static/media/hyperdrive.49ffc11b.png";